var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 122.88 122.88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.47,0h81.58a19.79,19.79,0,0,1,14,5.82l.32.35a19.79,19.79,0,0,1,5.5,13.66v83.22a19.91,19.91,0,0,1-19.83,19.83H19.83A19.91,19.91,0,0,1,0,103.05V21.47A21.56,21.56,0,0,1,21.47,0ZM52.11,89.08H33.45L47.78,33.8H75.1L89.43,89.08H70.77l-2-8.76H54.14l-2,8.76ZM61,50.78,57.33,66.26h8.14L61.93,50.78Zm42.1-40.67H21.47A11.37,11.37,0,0,0,10.11,21.47v81.58a9.77,9.77,0,0,0,9.72,9.72h83.22a9.73,9.73,0,0,0,9.72-9.72V19.83a9.73,9.73,0,0,0-2.62-6.64l-.24-.22a9.69,9.69,0,0,0-6.86-2.86Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAIcon);
export default __webpack_public_path__ + "static/media/aIcon.253999e3.svg";
export { ForwardRef as ReactComponent };